import React, { ReactNode } from 'react';
import { TopbarButtonProps, TopbarButton } from '@teko/teko-ecommerce';
import {
  BusinessCustomerOutlined,
  HeadphoneOutlined,
  IconBaseProps,
  ShowroomOutlined,
  TvNewOutlined,
} from '@teko/ds-icon';

type IconType = 'BusinessCustomerOutlined' | 'HeadphoneOutlined';

interface IconData {
  iconName: IconType;
  color: string;
  size: number;
}

export interface ITopBarButtonConfig extends TopbarButtonProps {
  key?: number;
  icon?: IconData;
}

/* map from iconName to component icon */
const m = new Map<string, React.ComponentType<IconBaseProps>>([
  ['BusinessCustomerOutlined', BusinessCustomerOutlined],
  ['HeadphoneOutlined', HeadphoneOutlined],
  ['TvNewOutlined', TvNewOutlined],
  ['ShowroomOutlined', ShowroomOutlined],
]);

const renderTopBarIcon = (iconData: IconData) => {
  const { iconName, ...rest } = iconData;
  const Comp = m.get(iconName);
  return <Comp {...rest} />;
};

/* render top bar button by its config */
export const renderTopBarButton = (
  topBarButtonConfig: ITopBarButtonConfig,
): ReactNode => {
  const { children, key, icon, ...rest } = topBarButtonConfig;
  const props = {
    ...(!!icon ? { icon: renderTopBarIcon(icon) } : {}),
    ...rest,
  };
  return (
    <TopbarButton {...props} key={key}>
      {children}
    </TopbarButton>
  );
};
